import { Injectable } from '@angular/core';
import { DbContext, DbTable } from '../data/dbcontext.service';
import { HttpClient } from '@angular/common/http';
import { ActionType, ErrorType, ValidationResult } from '../../models/projects/validation.models';
import * as moment from 'moment';
import { DailyLegLoad } from '../../models/daily-leg-loads/daily-leg-load.models';
import { AppConfig } from '../../app/app.config';
import { VesselService } from '../vessel/vessel.service';

@Injectable()
export class DailyLegLoadValidationService {
  private readonly legLoadDataTable: DbTable;

  config = AppConfig.settings;

  constructor(
    private http: HttpClient,
    private dbContext: DbContext,
    private vesselService: VesselService,
  ) {
    this.legLoadDataTable = this.dbContext.tables.find(t => t.name === 'LegLoadLogData');
  }

  async validateLegLoadLog(logs: DailyLegLoad[]): Promise<ValidationResult> {
    let validationResult = new ValidationResult();

    if (await this.vesselService.isCurrentVesselNonJacking()) {
      return validationResult;
    }

    for (let i = 0; i < logs.length; i++) {
      validationResult = await this.validateReading(logs[i], validationResult);
    }

    return validationResult;
  }

  async validateReading(reading: DailyLegLoad, validationResult: ValidationResult) {
    const currentTime = new Date;

    // add 15 minutes to time to give some leeway in how quickly validation is shown for unfilled times.
    const newReadingTime = moment(reading.date).add(15, 'm').toDate();

    if (!reading.disabled && (currentTime > newReadingTime)) {
      switch (reading.statusId) {
        case 1: {
          validationResult.addError(
            'A Leg Load reading for \'' + reading.timeShow + '\' has not yet been recorded.',
            ErrorType.Error,
            ActionType.DailyLegLoad);
          break;
        }
        case 2: {
          validationResult.addError(
            'A Leg Load reading for \'' + reading.timeShow + '\' needs to be completed. Not all mandatory fields have been recorded.',
            ErrorType.Error,
            ActionType.DailyLegLoad);
        }
          break;
      }
    }

    return validationResult;
  }
}



// WEBPACK FOOTER //
// ./src/services/daily-leg-loads/daily-leg-load-validation.service.ts